import Create from './create/CreateArtist';
import Edit from './edit/EditArtist';
import Individual from './individual/Artist';
import List from './list/Artists';

export default { List, Individual, Create, Edit };
